import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("convergen.lang") : null;
    return saved === "en" ? "en" : "es";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("convergen.lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const toggleLang = () => setLang((p) => (p === "es" ? "en" : "es"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
